
import NotificationsModalMailInfoView from "../notifications/NotificationsModalMailInfo.html";

angular.module("rgpd")

    .controller("NotificationsByPersonEditModalCtrl", ['$stateParams', 'notificationId', '$scope', '$uibModalInstance', '$uibModal', 'Restangular', '$filter', 'logService', function ($stateParams,notificationId, $scope, $uibModalInstance, $uibModal, Restangular, $filter, logService) {
        
        $scope.showData = 'showInfo';
        $scope.sent = 0;
        $scope.sending = 0;
        $scope.error = 0;
        $scope.eventId = null;
        if (typeof ($stateParams.id) !== 'undefined') {
            $scope.eventId = $stateParams.id;
        }

        Restangular.one('NotificationsEmails', notificationId).get().then(function (results) {
            logService.debug(results);
            $scope.notification = results;
            $scope.notification.content = (window as any).CONFIG.api_url + "NotificationsAttachment/GetContentHTML?id=" + $scope.notification.id;
                
            _.each($scope.notification.FK_notifications_attachments_notifications_emails, function (attachment) {
                attachment.downloadUrl = (window as any).CONFIG.api_url + 'NotificationsAttachment/getFile?uid=' + attachment.uid + '&filename=' + attachment.name
            });
            /*if ($scope.notification.program_template != null) {
                //Tiene programa, poner para que lo pueda descargar.
                if ($scope.notification.event_id != null) {
                    logService.debug("Entra en: " + $scope.notification.program_template, $scope.notification.event_id);

                    Restangular.all('EventProgram').getList({ event_id: $scope.notification.event_id }).then(function (eventProgram) {
                        logService.debug(eventProgram);
                        if (eventProgram.length > 0) {
                            $scope.eventProgramInformation = eventProgram[0];
                            logService.debug(CONFIG.api_url + 'EventProgram/getFile?uid=' + $scope.eventProgramInformation.file_uid + '&filename=' + $scope.eventProgramInformation.filename);
                            $scope.showFile = $scope.eventProgramInformation.filename != null;
                        }
                    });
                    //window.open(CONFIG.api_url + 'EventProgram/getFile?uid=' + $scope.eventProgramInformation.file_uid + '&filename=' + $scope.eventProgramInformation.filename, '_blank', '');
                }
            }*/
            }, function (response) {
                $scope.errorMessage = response.message;
                });
            
            $scope.goToEdit = function (rowEntity) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: NotificationsModalMailInfoView,
                    controller: 'NotificationsModalMailInfoCtrl',
                    size: 'lg',
                    resolve: {
                        id: function () { return rowEntity.id; }
                    }
                });

                $modalInstance.result.then(function (bool) {
                    toastr.success($filter('translate')('notifications.sending_mail_success'));
                    $scope.gridOptionNotifications.gridApi.core.raise.itemDeleted($scope);
                });
            }

        

        $scope.downloadFile = function (attachment) {
            window.open(attachment.downloadUrl, '_blank', '');
        }

        $scope.downloadFiles = function () {
            _.each($scope.notification.FK_notifications_attachments_notifications_emails, function (attachment) {
                window.open(attachment.downloadUrl, '_blank', '');
            });
        }

        $scope.addFile = function (flowFile) {
            var fileReader = new FileReader();
            fileReader.onload = function (event) {
                var uri = event.target.result;
                $scope.$apply(function () {
                    $scope.company.logo = uri;
                });
            };
            fileReader.readAsDataURL(flowFile.file);
        };


        $scope.setActive = function (data) {
            logService.debug(data);
            $scope.showData = data;
            logService.debug($scope.showData);
        }
        
        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])


    .controller('NotificationsModalMailInfoCtrl', ['$scope', '$uibModalInstance', '$http', 'Restangular', '$filter', 'id', function ($scope, $uibModalInstance, $http, Restangular, $filter, id) {
        
        Restangular.one('NotificationsTo', id).get().then(function (result) {
            $scope.notificationsEmailInfo = result;
        });

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

;